module.exports = __webpack_public_path__ + "img/image-download.be2045a0.png";